module dg.actions {
    angular.module('dg.actions', ['infinite-scroll',
        'ui.grid',
        'ui.grid.pagination',
        'ui.grid.infiniteScroll',
        'ui.grid.autoResize',
        'ui.tree',
        'ui.select',
        'ui.tinymce',
        'ui.bootstrap.datetimepicker']);
}